<script setup>
import InvitationDataClient from '@/components/invitation/components/data/client/InvitationDataClient.vue';

const props = defineProps({
    clients: Array
});
</script>

<template>
    <div class="invitation__data_client">
        <div class="form_header">
            {{ $t('client.client') }}
        </div>
        <div class="invitation_data_client_wrapper">
            <InvitationDataClient v-for="client in clients" 
                :client="client" 
            />
        </div>
    </div>
</template>